import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';

import './VideoPlayerPopup.css';

//Chromeless video player popup. show(url) opens it and the video autoplays from the start;
//the corner close icon (or Esc) pauses playback and closes it. The player element is only
//mounted while the popup is open (animation disabled so closing unmounts it immediately),
//which is what guarantees every open starts from the beginning.
class VideoPlayerPopup extends Component {

    constructor(props) {
        super(props);

        this.state = {
            showPopup: false,
            videoUrl: ''
        };

        this.videoRef = React.createRef();
    }

    show = (videoUrl) => {
        this.setState({
            showPopup: true,
            videoUrl: videoUrl
        });
    }

    handleClose = () => {

        //stop playback explicitly rather than relying on unmount timing
        if (this.videoRef.current)
        {
            this.videoRef.current.pause();
        }

        this.setState({
            showPopup: false,
            videoUrl: ''
        });
    }

    render() {
        return (
            <Modal
              className="videoPlayerRoot"
              backdropClassName="videoPlayerBackdrop"
              dialogClassName="videoPlayerModal"
              show={this.state.showPopup}
              onHide={this.handleClose}
              backdrop="static"
              animation={false}
              centered
            >
            <Modal.Body className="videoPlayerBody">
                <button type="button" className="videoPlayerClose" aria-label="Close video" onClick={this.handleClose}>
                    <svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true">
                        <path d="M3 3 L13 13 M13 3 L3 13" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </button>
                <video
                    ref={this.videoRef}
                    className="videoPlayerVideo"
                    src={this.state.videoUrl}
                    controls
                    autoPlay
                />
            </Modal.Body>
            </Modal>
        )
    }
}

export default VideoPlayerPopup;
